import { render, staticRenderFns } from "./PaymentAccountNumberCmp.vue?vue&type=template&id=c843b608&scoped=true"
import script from "./PaymentAccountNumberCmp.vue?vue&type=script&lang=js"
export * from "./PaymentAccountNumberCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c843b608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c843b608')) {
      api.createRecord('c843b608', component.options)
    } else {
      api.reload('c843b608', component.options)
    }
    module.hot.accept("./PaymentAccountNumberCmp.vue?vue&type=template&id=c843b608&scoped=true", function () {
      api.rerender('c843b608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimStatement/cmp/PaymentAccountNumberCmp.vue"
export default component.exports